import { Accordion, Button } from '@fluentui/react-components';
import { AddCircleRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { FlexBox } from '../../shared-components/flex-box';
import './CustomerReferenceForm.scss';
import { CustomerReferenceFormInputs } from './CustomerReferenceFormInputs';

const MAX_CUSTOMER_REFERENCES = 3;

const CustomerReferenceFormImpl: React.FC = () => {
  const {
    nominationWizardPageUiStore,
  } = useStores();

  return (
    <FlexBox
      direction='column'
      isFullWidth
      className='customer-reference-form'
    >
      <Accordion<string>
        collapsible
        multiple
        openItems={nominationWizardPageUiStore.expandedCustomerReferenceKeys}
        onToggle={(_, data) => {
          if (!data.openItems.includes((data.value))) {
            nominationWizardPageUiStore.collapseCustomerReference(data.value);
          } else {
            nominationWizardPageUiStore.expandCustomerReference(data.value);
          }
        }}
      >
        {
          nominationWizardPageUiStore.nomination.customerReferences.map((customerReference, customerReferenceIndex) => {
            const rowKey = nominationWizardPageUiStore.customerReferenceRowKeys[customerReferenceIndex];

            return (
              <CustomerReferenceFormInputs
                key={rowKey}
                rowKey={rowKey}
                customerReferenceIndex={customerReferenceIndex}
                customerReference={customerReference}
                onRemoveCustomerReference={() => nominationWizardPageUiStore.removeCustomerReference(customerReferenceIndex)}
              />
            );
          })
        }
      </Accordion>
      {
        nominationWizardPageUiStore.nomination.customerReferences.length < MAX_CUSTOMER_REFERENCES &&
        <div>
          <Button
            appearance='primary'
            icon={<AddCircleRegular />}
            onClick={() => nominationWizardPageUiStore.addCustomerReference()}
          >
            Add Customer Reference
          </Button>
        </div>
      }
    </FlexBox>
  );
}

export const CustomerReferenceForm = observer(CustomerReferenceFormImpl);
